module.exports = __webpack_public_path__ + "media/images/sp/banner/visit_reserve-efd27fd0c25641b93e119e6fce0629a2.png";